import type { TranslationKeysError } from '../localeType';

export const itIT_error: TranslationKeysError = {
  error: 'Errore : ',
  // Update ORDER
  ORDER_NOT_FOUND: `L'ordine non è stato trovato`,
  ORDER_SUSPENDED: `L'ordine è sospeso`,
  ORDER_IN_USE: `L'ordine è già in uso`,
  FLORIST_NOT_FOUND: `L'identificativo del fiorista non è stato trovato`,
  NOTIFICATION_CHANNEL_EMPTY: `Si è verificato un errore nel sistema`,
  UPDATE_NOT_ALLOWED_WRONG_STATUS: `L'ordine non può essere aggiornato a questo stato`,
  UPDATE_NOT_ALLOWED_WRONG_EXECUTOR: `L'ordine non può essere aggiornato dall'utente`,
  UPDATE_KO: `Lo stato dell'ordine è stato aggiornato ma c'è un errore da controllare relativo alla fatturazione`,
  EXCEPTION: `L'ordine non può essere aggiornato. Si è verificato un errore`,
  UNKNOWN_EXCEPTION: `L'ordine non può essere aggiornato. Si è verificato un errore`,
  OrderNotFoundException: `L'ordine non è stato trovato nel sistema`,
  IncorrectOrderActionException: `L'azione richiesta non è supportata`,
  OrderStatusNotConsistentException: `Il nuovo stato richiesto per l'ordine non è possibile`,
  InvariantException: `Errore tecnico nel sistema: HTTP BAD REQUEST`,
  // POST ORDER
  IncorrectBodyModelException: `Trasmissione fallita: Errore interno - Codice errore: PO-01`,
  IncorrectOrderException: `Trasmissione fallita: Errore interno - Codice errore: PO-02`,
  BadRequestException: `Trasmissione fallita: Errore interno - Codice errore: PO-03`,
  Exception: `Trasmissione fallita: Errore interno - Codice errore: PO-04`,
  FeasabilityExceptionRaoKo: 'Trasmissione fallita: Errore interno - Codice errore: PO-05',
  FeasabilityExceptionRaoResponseDataKo: `Trasmissione fallita: Errore interno - Codice errore: PO-06`,
  FeasabilityExceptionEmptyFlorists: '`Trasmissione fallita: Errore interno - Codice errore: PO-07`',
  PersonalCodeExceptionPersonalCodeNotFound: `Trasmissione fallita: Errore interno - Codice errore: PO-08`,
  PersonalCodeExceptionExecutingFloristMismatch: `Trasmissione fallita: Errore interno - Codice errore: PO-09`,
  ValidationException: 'Validazione dell’ordine impossibile (campi mancanti) - Codice errore: PO-10',
  PersonalCodeNeededPsm: 'Approvazione preventiva necessaria per prodotto su misura (PSM) - Codice errore: PO-11',
  PersonalCodeNeededXProduct:
    'Approvazione preventiva necessaria per prodotto con codice che termina con X - Codice errore: PO-12',
  PersonalCodeNeededPrice:
    'Il prezzo supera la dimensione extra-large, è necessario un codice di approvazione - Codice errore: PO-12',
  PersonalCodeNeededPreparationTime:
    'Approvazione preventiva necessaria, tempo di preparazione troppo breve - Codice errore: PO-13',
  PersonalCodeNeededHourLimit:
    'Approvazione preventiva necessaria, tempo di consegna troppo breve per l’orario scelto - Codice errore: PO-14',
  SelectedExecutingFloristNotFound: `Fiorista esecutore non trovato - Codice errore: PO-15`,
  UpdatePersonalCodeKO: 'Impossibile aggiornare il codice AP perché è già in uso.',

  // LOGIN
  loginError: {
    floristUnknown: {
      title: `The florist's login was not found.`,
      body: `Please click on the "Logout" button.`,
    },
    noCountryCode: {
      title: `The florist's country code was not found.`,
      body: `Please click on the "Logout" button.`,
    },
    logoutButton: 'Logout',
  },
};
